import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { lazyWithPreload, withComponentPreloading } from 'utils/bundle';

import type { CodeDataForm } from './features/types';

const PhoneNumberPage = lazyWithPreload(() => import('./features/phone-number-page'));
PhoneNumberPage.preload();

const VerifyCodePage = lazyWithPreload(() => import('pages/login/features/verify-code-page'));
const PartnerRegisterPage = lazyWithPreload(() => import('pages/login/features/partner-register-page'));
const PartnerVerifyEmail = lazyWithPreload(() => import('pages/login/features/partner-verify-email-page'));
const RegisterPage = lazyWithPreload(() => import('pages/login/features/register-page'));
const VerifyEmailPage = lazyWithPreload(() => import('pages/login/features/verify-email-page'));

interface Props {}

const Login: React.FC<Props> = () => {
  const navigate = useNavigate();

  const handleVerifyCodeSuccess = (data: CodeDataForm) => {
    if (data.deformedEmail) {
      // deformed email exists
      navigate('./verifyEmail', {
        state: {
          phone: data.phone,
          code: data.code,
          deformedEmail: data.deformedEmail,
        },
      });
    } else {
      navigate('./register', {
        state: {
          phone: data.phone,
          code: data.code,
          country: data.country,
        },
      });
    }
  };

  return (
    <Routes>
      <Route index element={<PhoneNumberPage />} />
      <Route path="verifyCode" element={<VerifyCodePage onSuccess={handleVerifyCodeSuccess} />} />
      <Route path="verifyEmail/partner" element={<PartnerVerifyEmail />} />
      <Route path="verifyEmail" element={<VerifyEmailPage />} />
      <Route path="register/partner" element={<PartnerRegisterPage />} />
      <Route path="register" element={<RegisterPage />} />
    </Routes>
  );
};

export default withComponentPreloading<Props>({
  components: [VerifyCodePage, PartnerRegisterPage, PartnerVerifyEmail, RegisterPage, VerifyEmailPage],
})(Login);
